

// دالة لتحسين الصور
export const optimizeImage = (file, maxWidth = 800, quality = 0.8) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      // حساب الأبعاد الجديدة
      let { width, height } = img;
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }
      
      canvas.width = width;
      canvas.height = height;
      
      // رسم الصورة المحسنة
      ctx.drawImage(img, 0, 0, width, height);
      
      // تحويل إلى blob
      canvas.toBlob(resolve, 'image/jpeg', quality);
    };
    
    img.src = URL.createObjectURL(file);
  });
};

// دالة لضغط الملفات
export const compressFiles = async (files, options = {}) => {
  const { maxSize = 500000, quality = 0.8 } = options; // 500KB default
  
  const compressedFiles = [];
  
  for (const file of files) {
    if (file.size <= maxSize) {
      compressedFiles.push(file);
      continue;
    }
    
    try {
      const compressedFile = await optimizeImage(file, 800, quality);
      compressedFiles.push(compressedFile);
    } catch (error) {
      compressedFiles.push(file);
    }
  }
  
  return compressedFiles;
};

// دالة لتحسين FormData
export const optimizeFormData = (formData) => {
  const optimizedFormData = new FormData();
  
  for (const [key, value] of formData.entries()) {
    if (value instanceof File) {
      // تحسين الملفات
      optimizedFormData.append(key, value);
    } else {
      optimizedFormData.append(key, value);
    }
  }
  
  return optimizedFormData;
};

// دالة للتحقق من صحة البيانات قبل الإرسال
export const validateFormData = (formData, requiredFields = []) => {
  const errors = [];
  
  for (const field of requiredFields) {
    if (!formData.get(field) || formData.get(field).toString().trim() === '') {
      errors.push(`${field} مطلوب`);
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// دالة لتحسين طلبات API المتعددة
export const batchApiRequests = async (requests, batchSize = 3) => {
  const results = [];
  
  for (let i = 0; i < requests.length; i += batchSize) {
    const batch = requests.slice(i, i + batchSize);
    const batchResults = await Promise.all(batch);
    results.push(...batchResults);
  }
  
  return results;
};

// دالة لتحسين الذاكرة
export const clearMemory = () => {
  if (window.gc) {
    window.gc();
  }
  
  // مسح cache الصور
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    if (img.src.startsWith('blob:')) {
      URL.revokeObjectURL(img.src);
    }
  });
};

// دالة لتحسين التحميل
export const preloadData = async (urls) => {
  const promises = urls.map(url => 
    fetch(url, { 
      method: 'HEAD',
      cache: 'force-cache'
    }).catch(() => null)
  );
  
  await Promise.all(promises);
};

// دالة لتحسين التخزين المؤقت
export const cacheData = (key, data, ttl = 300000) => { // 5 دقائق افتراضياً
  const cacheItem = {
    data,
    timestamp: Date.now(),
    ttl
  };
  
  try {
    sessionStorage.setItem(`cache_${key}`, JSON.stringify(cacheItem));
  } catch (error) {
  }
};

// دالة لاسترجاع البيانات من التخزين المؤقت
export const getCachedData = (key) => {
  try {
    const cached = sessionStorage.getItem(`cache_${key}`);
    if (!cached) return null;
    
    const cacheItem = JSON.parse(cached);
    const now = Date.now();
    
    if (now - cacheItem.timestamp > cacheItem.ttl) {
      sessionStorage.removeItem(`cache_${key}`);
      return null;
    }
    
    return cacheItem.data;
  } catch (error) {
    return null;
  }
};

// دالة لتحسين التحميل التدريجي
export const progressiveLoad = async (items, batchSize = 10, onBatchLoad) => {
  const results = [];
  
  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchResults = await Promise.all(batch);
    results.push(...batchResults);
    
    if (onBatchLoad) {
      onBatchLoad(results);
    }
    
    // إعطاء فرصة للمتصفح لمعالجة التحديثات
    await new Promise(resolve => setTimeout(resolve, 0));
  }
  
  return results;
};
